import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  children: React.ReactNode;
  inverted?: boolean;
  className?: string;
}
export const slideVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1],
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function Slide({
  children,
  inverted = false,
  className = ''
}: SlideProps) {
  return <motion.div variants={slideVariants} initial="hidden" animate="visible" exit="exit" className={`absolute inset-0 w-full h-full flex flex-col px-6 md:px-16 py-10 md:py-16 overflow-y-auto overscroll-contain ${inverted ? 'bg-white text-black' : 'bg-black text-white'} ${className}`} data-id="element-69">
      {children}
    </motion.div>;
}
export function SlideHeader({
  children,
  inverted = false
}: {
  children: React.ReactNode;
  inverted?: boolean;
}) {
  return <motion.div variants={itemVariants} className="w-full mb-10 md:mb-24 shrink-0" data-id="element-70">
      <div className={`w-full h-px mb-6 ${inverted ? 'bg-black' : 'bg-white'}`} data-id="element-71" />
      <h2 className="text-sm md:text-base font-medium tracking-widest uppercase" data-id="element-72">
        {children}
      </h2>
    </motion.div>;
}
export function SlideContent({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`flex-1 w-full grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 ${className}`} data-id="element-73">
      {children}
    </div>;
}